import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-01877e99"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  autoplay: "",
  loop: "",
  muted: "",
  controls: false,
  style: {"width":"100vw","height":"100vh","z-index":"-100","position":"absolute","top":"0","left":"0"}
}
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "screen-4k grid grid-nogutter" }
const _hoisted_4 = { class: "text-white p-0 my-auto mr-auto ml-4" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "my-auto",
  src: "assets/logo.png",
  style: { height: '50px' }
}, null, -1))
const _hoisted_6 = {
  class: "text-white p-0 my-auto mx-2",
  style: { 'font-size': '23px' }
}
const _hoisted_7 = { class: "text-white p-0 my-auto ml-auto mr-4" }
const _hoisted_8 = { class: "col-10 grid grid-nogutter" }
const _hoisted_9 = { class: "col-2 grid grid-nogutter" }
const _hoisted_10 = {
  class: "grid grid-nogutter",
  style: {"width":"20%"}
}
const _hoisted_11 = { class: "col-12 px-1 py-2" }
const _hoisted_12 = { class: "col-12 px-1 py-0 mb-3" }
const _hoisted_13 = {
  class: "grid grid-nogutter",
  style: {"width":"80%"}
}
const _hoisted_14 = { class: "col-3 px-1 py-2" }
const _hoisted_15 = { class: "col-3 px-1 py-2" }
const _hoisted_16 = { class: "col-3 px-1 py-2" }
const _hoisted_17 = { class: "col-3 px-1 py-2" }
const _hoisted_18 = { class: "col-3 px-1 py-2" }
const _hoisted_19 = { class: "col-3 px-1 py-2" }
const _hoisted_20 = { class: "col-3 px-1 py-2" }
const _hoisted_21 = { class: "col-3 px-1 py-2" }
const _hoisted_22 = { class: "col-3 px-1 py-0 mb-4" }
const _hoisted_23 = { class: "col-3 px-1 py-0 mb-4" }
const _hoisted_24 = { class: "col-3 px-1 py-0 mb-4" }
const _hoisted_25 = { class: "col-3 px-1 py-0 mb-4" }

import { computed, onMounted, onUnmounted, ref } from "vue";
import { useDisplay } from "./composables/useDisplay";
import UsaGameBoard from "../components/UsaGameBoard.vue";
import RdUsaGameBoard from "../components/RdUsaGameBoard.vue";
import RdUsaGameBoardMini from "../components/RdUsaGameBoardMini.vue";
import RdGameBoard from "../components/RdGameBoard.vue";
import AnguilaGameBoard from "../components/AnguilaGameBoard.vue";
import env from "@/env.json";
import UsaGameBoardMini from "../components/UsaGameBoardMini.vue";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const secondsToRefreshInfo = 5 * 60;
const defaultSecondsToChangeScreen = 5 * 60;


export default /*#__PURE__*/_defineComponent({
  __name: 'DisplayUsa',
  setup(__props) {

const intervals: any[] = [];
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const timeouts: any[] = [];
const loading = ref(true);
const url = `${env.API_URL}/usa`;
const screenWidth = ref(0);
const screenHeight = ref(0);
const xMargin = ref(5);
const extraH = ref(1.45);
const extraHT = ref(1.8);

const videoSrc = ref(`${env.API_URL}/video`);

const { wakelock, currents, date, isToday, isUsa, dteRef, dteComputed, changeOnRef, changeOnComputed, updateCurrent, getInfo } = useDisplay(url);

const setChangeScreen = () => {
  changeOnRef.value = currents.value?.seconds ?? defaultSecondsToChangeScreen;

  timeouts.push(
    setTimeout(() => {
      changeOnRef.value = 0;

      timeouts.pop();

      updateCurrent();

      setChangeScreen();
    }, (currents.value?.seconds ?? defaultSecondsToChangeScreen) * 1000),
  );
};

onMounted(async () => {
  screenHeight.value = screen.availHeight;
  screenWidth.value = screen.availWidth;

  await getInfo();

  loading.value = false;

  intervals.push(setInterval(getInfo, secondsToRefreshInfo * 1000));
  intervals.push(setInterval(() => (dteRef.value = new Date()), 500));
  intervals.push(
    setInterval(() => {
      changeOnRef.value -= 1;
      if (changeOnRef.value < 0) {
        changeOnRef.value = 0;
      }
    }, 1000),
  );

  setChangeScreen();
});

onUnmounted(() => {
  for (const interval of intervals) {
    clearInterval(interval);
  }

  for (const timeout of timeouts) {
    clearTimeout(timeout);
  }

  wakelock.value?.release();
});

const ny = computed(() => currents.value?.results.find((current) => current.states === "NEW YORK"));
const fl = computed(() => currents.value?.results.find((current) => current.states === "FLORIDA"));
const nj = computed(() => currents.value?.results.find((current) => current.states === "NEW JERSEY"));
const cn = computed(() => currents.value?.results.find((current) => current.states === "CONNECTICUT "));
const ms = computed(() => currents.value?.results.find((current) => current.states === "MASSACHUSETTS"));
const ge = computed(() => currents.value?.results.find((current) => current.states === "GEORGIA"));
const il = computed(() => currents.value?.results.find((current) => current.states === "ILLINOIS"));
const nc = computed(() => currents.value?.results.find((current) => current.states === "NORTH CAROLINA"));
const pn = computed(() => currents.value?.results.find((current) => current.states === "PENNSYLVANIA"));
const ml = computed(() => currents.value?.results.find((current) => current.states === "MARYLAND"));
const ca = computed(() => currents.value?.results.find((current) => current.states === "CALIFORNIA"));
const de = computed(() => currents.value?.results.find((current) => current.states === "DELAWARE"));
const id = computed(() => currents.value?.results.find((current) => current.states === "INDIANA"));
const sc = computed(() => currents.value?.results.find((current) => current.states === "SOUTH CAROLINA"));
const vi = computed(() => currents.value?.results.find((current) => current.states === "VIRGINIA"));
// const wv = computed(() => currents.value?.results.find((current) => current.states === "WEST VIRGINIA"));
const tx = computed(() => currents.value?.results.find((current) => current.states === "TEXAS"));

const lottery18 = computed(() => currents.value?.results.find((current) => current.id === 18));
const lottery19 = computed(() => currents.value?.results.find((current) => current.id === 19));
const lottery20 = computed(() => currents.value?.results.find((current) => current.id === 20));
const lottery21 = computed(() => currents.value?.results.find((current) => current.id === 21));
const lottery22 = computed(() => currents.value?.results.find((current) => current.id === 22));
const lottery23 = computed(() => currents.value?.results.find((current) => current.id === 23));
const lottery24 = computed(() => currents.value?.results.find((current) => current.id === 24));
const lottery25 = computed(() => currents.value?.results.find((current) => current.id === 25));
const lottery26 = computed(() => currents.value?.results.find((current) => current.id === 26));
const lottery27 = computed(() => currents.value?.results.find((current) => current.id === 27));

// const nyh = computed(() => currents.value?.results.find((current) => current.id === 28));
const lottery33 = computed(() => currents.value?.results.find((current) => current.id === 33));

const lottery29 = computed(() => currents.value?.results.find((current) => current.id === 29));
const lottery30 = computed(() => currents.value?.results.find((current) => current.id === 30));
const lottery31 = computed(() => currents.value?.results.find((current) => current.id === 31));
const lottery32 = computed(() => currents.value?.results.find((current) => current.id === 32));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("video", _hoisted_1, [
      _createElementVNode("source", {
        src: videoSrc.value,
        type: "video/mp4"
      }, null, 8, _hoisted_2)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", {
        class: "col-12 flex justify-content-center align-content-between mx-0 p-0",
        style: _normalizeStyle([{"margin-top":"2px !important","height":"50px"}, { marginBottom: `0` }])
      }, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(changeOnComputed)), 1),
        _hoisted_5,
        _createElementVNode("h1", _hoisted_6, _toDisplayString(_unref(isToday) ? "TODAY'" : "YESTERDAY'") + " " + _toDisplayString(_unref(date)), 1),
        _createElementVNode("i", {
          class: _normalizeClass(["pi pi-circle-fill my-auto", { 'text-green-500': _unref(isToday), 'text-red-500': !_unref(isToday) }]),
          style: { 'font-size': '22px' }
        }, null, 2),
        _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(dteComputed)), 1)
      ]),
      (_unref(isUsa))
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", {
                class: "col-fixed mx-1",
                style: _normalizeStyle({ width: `calc(20% - 0.5rem)`, height: `calc((100% - 50px) / 3)` })
              }, [
                _createVNode(UsaGameBoard, {
                  info: ny.value,
                  isToday: _unref(isToday),
                  inline: true,
                  showName: true
                }, null, 8, ["info", "isToday"])
              ], 4),
              _createElementVNode("div", {
                class: "col-fixed mx-1",
                style: _normalizeStyle({ width: `calc(20% - 0.5rem)`, height: `calc((100% - 50px) / 3)` })
              }, [
                _createVNode(UsaGameBoardMini, {
                  info: fl.value,
                  isToday: _unref(isToday),
                  inline: true,
                  showName: true
                }, null, 8, ["info", "isToday"])
              ], 4),
              _createElementVNode("div", {
                class: "col-fixed mx-1",
                style: _normalizeStyle({ width: `calc(20% - 0.5rem)`, height: `calc((100% - 50px) / 3)` })
              }, [
                _createVNode(UsaGameBoard, {
                  info: nj.value,
                  isToday: _unref(isToday),
                  inline: true,
                  showName: true
                }, null, 8, ["info", "isToday"])
              ], 4),
              _createElementVNode("div", {
                class: "col-fixed mx-1",
                style: _normalizeStyle({ width: `calc(20% - 0.5rem)`, height: `calc((100% - 50px) / 3)` })
              }, [
                _createVNode(UsaGameBoard, {
                  info: cn.value,
                  isToday: _unref(isToday),
                  inline: true,
                  showName: true
                }, null, 8, ["info", "isToday"])
              ], 4),
              _createElementVNode("div", {
                class: "col-fixed mx-1",
                style: _normalizeStyle({ width: `calc(20% - 0.5rem)`, height: `calc((100% - 50px) / 3)` })
              }, [
                _createVNode(UsaGameBoard, {
                  info: ms.value,
                  isToday: _unref(isToday),
                  inline: false,
                  showName: true
                }, null, 8, ["info", "isToday"])
              ], 4),
              _createElementVNode("div", {
                class: "col-fixed mx-1",
                style: _normalizeStyle({ width: `calc(20% - 0.5rem)`, height: `calc((100% - 50px) / 3)` })
              }, [
                _createVNode(UsaGameBoard, {
                  info: lottery33.value,
                  isToday: _unref(isToday),
                  inline: false,
                  showName: true
                }, null, 8, ["info", "isToday"])
              ], 4),
              _createElementVNode("div", {
                class: "col-fixed mx-1",
                style: _normalizeStyle({ width: `calc(20% - 0.5rem)`, height: `calc((100% - 50px) / 3)` })
              }, [
                _createVNode(UsaGameBoard, {
                  info: nc.value,
                  isToday: _unref(isToday),
                  inline: true,
                  showName: true
                }, null, 8, ["info", "isToday"])
              ], 4),
              _createElementVNode("div", {
                class: "col-fixed mx-1",
                style: _normalizeStyle({ width: `calc(20% - 0.5rem)`, height: `calc((100% - 50px) / 3)` })
              }, [
                _createVNode(UsaGameBoard, {
                  info: pn.value,
                  isToday: _unref(isToday),
                  inline: true,
                  showName: true
                }, null, 8, ["info", "isToday"])
              ], 4),
              _createElementVNode("div", {
                class: "col-fixed mx-1",
                style: _normalizeStyle({ width: `calc(20% - 0.5rem)`, height: `calc((100% - 50px) / 3)` })
              }, [
                _createVNode(UsaGameBoard, {
                  info: ml.value,
                  isToday: _unref(isToday),
                  inline: true,
                  showName: true
                }, null, 8, ["info", "isToday"])
              ], 4),
              _createElementVNode("div", {
                class: "col-fixed mx-1",
                style: _normalizeStyle({ width: `calc(20% - 0.5rem)`, height: `calc((100% - 50px) / 3)` })
              }, [
                _createVNode(UsaGameBoard, {
                  info: ca.value,
                  isToday: _unref(isToday),
                  inline: true,
                  showName: true
                }, null, 8, ["info", "isToday"])
              ], 4),
              _createElementVNode("div", {
                class: "col-fixed mx-1",
                style: _normalizeStyle({ width: `calc(20% - 0.5rem)`, height: `calc((100% - 50px) / 3)` })
              }, [
                _createVNode(UsaGameBoard, {
                  info: de.value,
                  isToday: _unref(isToday),
                  inline: true,
                  showName: true
                }, null, 8, ["info", "isToday"])
              ], 4),
              _createElementVNode("div", {
                class: "col-fixed mx-1",
                style: _normalizeStyle({ width: `calc(20% - 0.5rem)`, height: `calc((100% - 50px) / 3)` })
              }, [
                _createVNode(UsaGameBoard, {
                  info: id.value,
                  isToday: _unref(isToday),
                  inline: true,
                  showName: true
                }, null, 8, ["info", "isToday"])
              ], 4),
              _createElementVNode("div", {
                class: "col-fixed mx-1",
                style: _normalizeStyle({ width: `calc(20% - 0.5rem)`, height: `calc((100% - 50px) / 3)` })
              }, [
                _createVNode(UsaGameBoard, {
                  info: sc.value,
                  isToday: _unref(isToday),
                  inline: true,
                  showName: true
                }, null, 8, ["info", "isToday"])
              ], 4),
              _createElementVNode("div", {
                class: "col-fixed mx-1",
                style: _normalizeStyle({ width: `calc(20% - 0.5rem)`, height: `calc((100% - 50px) / 3)` })
              }, [
                _createVNode(UsaGameBoard, {
                  info: vi.value,
                  isToday: _unref(isToday),
                  inline: true,
                  showName: true
                }, null, 8, ["info", "isToday"])
              ], 4),
              _createElementVNode("div", {
                class: "col-fixed mx-1",
                style: _normalizeStyle({ width: `calc(20% - 0.5rem)`, height: `calc((100% - 50px) / 3)` })
              }, [
                _createVNode(UsaGameBoard, {
                  info: il.value,
                  isToday: _unref(isToday),
                  inline: true,
                  showName: true
                }, null, 8, ["info", "isToday"])
              ], 4)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", {
                class: "col-12 pr-1",
                style: _normalizeStyle({ height: `calc((100% - 50px) * (6/13))` })
              }, [
                _createVNode(UsaGameBoard, {
                  info: ge.value,
                  isToday: _unref(isToday),
                  inline: true,
                  showName: true
                }, null, 8, ["info", "isToday"])
              ], 4),
              _createElementVNode("div", {
                class: "col-12 pr-1",
                style: _normalizeStyle({ height: `calc((100% - 50px) * (7/13))` })
              }, [
                _createVNode(UsaGameBoardMini, {
                  info: tx.value,
                  isToday: _unref(isToday),
                  inline: true,
                  showName: true
                }, null, 8, ["info", "isToday"])
              ], 4)
            ])
          ], 64))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createVNode(RdUsaGameBoardMini, {
                  info: lottery32.value,
                  isToday: _unref(isToday),
                  inline: true,
                  showName: true
                }, null, 8, ["info", "isToday"])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createVNode(AnguilaGameBoard, {
                  info: lottery27.value,
                  isToday: _unref(isToday)
                }, null, 8, ["info", "isToday"])
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createVNode(RdGameBoard, {
                  info: lottery18.value,
                  isToday: _unref(isToday)
                }, null, 8, ["info", "isToday"])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createVNode(RdGameBoard, {
                  info: lottery19.value,
                  isToday: _unref(isToday)
                }, null, 8, ["info", "isToday"])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createVNode(RdGameBoard, {
                  info: lottery20.value,
                  isToday: _unref(isToday)
                }, null, 8, ["info", "isToday"])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createVNode(RdGameBoard, {
                  info: lottery21.value,
                  isToday: _unref(isToday)
                }, null, 8, ["info", "isToday"])
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createVNode(RdGameBoard, {
                  info: lottery22.value,
                  isToday: _unref(isToday)
                }, null, 8, ["info", "isToday"])
              ]),
              _createElementVNode("div", _hoisted_19, [
                _createVNode(RdGameBoard, {
                  info: lottery23.value,
                  isToday: _unref(isToday)
                }, null, 8, ["info", "isToday"])
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createVNode(RdGameBoard, {
                  info: lottery24.value,
                  isToday: _unref(isToday)
                }, null, 8, ["info", "isToday"])
              ]),
              _createElementVNode("div", _hoisted_21, [
                _createVNode(RdGameBoard, {
                  info: lottery25.value,
                  isToday: _unref(isToday)
                }, null, 8, ["info", "isToday"])
              ]),
              _createElementVNode("div", _hoisted_22, [
                _createVNode(RdGameBoard, {
                  info: lottery26.value,
                  isToday: _unref(isToday)
                }, null, 8, ["info", "isToday"])
              ]),
              _createElementVNode("div", _hoisted_23, [
                _createVNode(RdUsaGameBoard, {
                  info: lottery29.value,
                  isToday: _unref(isToday),
                  inline: true,
                  showName: true
                }, null, 8, ["info", "isToday"])
              ]),
              _createElementVNode("div", _hoisted_24, [
                _createVNode(RdUsaGameBoard, {
                  info: lottery30.value,
                  isToday: _unref(isToday),
                  inline: true,
                  showName: true
                }, null, 8, ["info", "isToday"])
              ]),
              _createElementVNode("div", _hoisted_25, [
                _createVNode(RdUsaGameBoard, {
                  info: lottery31.value,
                  isToday: _unref(isToday),
                  inline: true,
                  showName: true
                }, null, 8, ["info", "isToday"])
              ])
            ])
          ], 64))
    ])
  ], 64))
}
}

})